import type { PromptTemplate } from './prompt-template.interface'

/**
 * Checks if a prompt template matches a search string by name or description.
 */
export const filterTemplateBySearch = (template: PromptTemplate, search: string): boolean => {
  const searchLower = search.toLowerCase()
  const matchesName = template.name.toLowerCase().includes(searchLower)
  const matchesDescription = template.description.toLowerCase().includes(searchLower)
  return matchesName || matchesDescription
}

/**
 * Creates a cmdk-compatible filter function for prompt templates.
 * Returns 1 (match) or 0 (no match) based on name/description search.
 */
export const createPromptTemplateFilter = (
  templateList: PromptTemplate[]
): ((itemValue: string, search: string) => number) => {
  return (itemValue: string, search: string): number => {
    const template = templateList.find((t) => t.id === itemValue)
    if (!template) return 0
    return filterTemplateBySearch(template, search) ? 1 : 0
  }
}
